import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Filter, RestClientPaged } from '@elderbyte/ngx-starter'
import { environment } from '../../../../environments/environment'
import { WorkStation } from './work-station'

export class WorkStationFilter {
  public static facility(facilityId: string): Filter {
    return new Filter('facility', facilityId)
  }
}

@Injectable({
  providedIn: 'root',
})
export class WorkStationService extends RestClientPaged<WorkStation, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/work-stations', http, {
      idField: 'id',
    })
  }
}
